import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import {
  AccountBalance,
  AccountBalanceWallet,
  ExpandMore,
  Home,
  Inventory,
  Logout, Mail,
  Person,
  Savings
} from "@mui/icons-material";
import ListItemLink from "./ListItemLink";
import useAuth from "../hooks/use-auth";
import {Accordion, AccordionDetails, AccordionSummary, Paper, Skeleton, Typography} from "@mui/material";
import {formatPrice} from "src/functions/priceFormatter";
import PropTypes from "prop-types";

const SideNavigation = ({ isMobile = false }) => {
  const { onLogout, myUser } = useAuth();

  const handleLogout = () => {
    onLogout();
  }

  const navList = (
    <List>
      <ListItemLink primary={'Dashboard'} icon={<Home />} to={'/'} />
      <ListItemLink primary={'Projecten'} icon={<Inventory />} to={'/projecten'} />
      <ListItemLink primary={'Uitbetalingen'} icon={<Savings />} to={'/account/uitbetalingen'} />
      <ListItemLink primary={'Saldo'} icon={<AccountBalanceWallet />} to={'/account/saldo'} />
      <ListItemLink primary={'Rekeningnummer wijzigen'} icon={<AccountBalance />} to={'/account/rekeningnummer-wijzigen'} />
      <ListItemLink primary={'Mijn gegevens'} icon={<Person />} to={'/account/mijn-gegevens'} />
      <ListItemLink primary={'Iemand uitnodigen'} icon={<Mail />} to={'/account/iemand-uitnodigen'} />
      <ListItem disablePadding>
        <ListItemButton component="a" onClick={handleLogout}>
          <ListItemIcon><Logout /></ListItemIcon>
          <ListItemText primary={'Uitloggen'} />
        </ListItemButton>
      </ListItem>
    </List>
  )

  const navBarElement =  (
    <Paper sx={{bgcolor: "neutral.main", p: 3}}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography component="span" color="primary" display="inline-block" sx={{fontSize: "2rem"}}>Saldo</Typography>
        {
          myUser && null !== myUser.accountBalance
            ? <Typography component="span" color="primary" variant="body1" display="inline-block" fontWeight="bold">{formatPrice(myUser.accountBalance)}</Typography>
            : (
              <Skeleton>
                <Typography component="span" color="primary" variant="body1" display="inline-block" fontWeight="bold"></Typography>
              </Skeleton>
            )
        }
      </Box>

      <Divider variant="middle" />

      { isMobile && (
        <Accordion sx={{bgcolor: "neutral.main"}} disableGutters elevation={0}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            Navigeren naar
          </AccordionSummary>
          <AccordionDetails>
            {navList}
          </AccordionDetails>
        </Accordion>
      )}

      { !isMobile && navList }

    </Paper>
  )

  return navBarElement;
}

export default SideNavigation;

SideNavigation.propTypes = {
  isMobile: PropTypes.bool
}

SideNavigation.defaultProps = {
  isMobile: false,
}